var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown01StrokeSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99977 9.00005L11.9998 15L17.9998 9",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown01StrokeSharp);
export default __webpack_public_path__ + "static/media/arrow-down-01-stroke-sharp.d4dfd50315b5f86fbc975f403e2f0e73.svg";
export { ForwardRef as ReactComponent };